import moment, {type Moment} from 'moment-timezone'
import type {ParserT} from '@freckle/parser'
import {date, mapStatic, nullable, Parser, record} from '@freckle/parser'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type PremiumCutoff = Moment

export type PremiumLicensesAttrs = {
  mathPremiumUntil: Moment | undefined | null
  elaPremiumUntil: Moment | undefined | null
  socialStudiesPremiumUntil: Moment | undefined | null
  sciencePremiumUntil: Moment | undefined | null
  premiumCutoff: PremiumCutoff
}

export const parsePremiumLicensesAttrs: ParserT<PremiumLicensesAttrs> = record({
  mathPremiumUntil: nullable(mapStatic(date(), moment)),
  elaPremiumUntil: nullable(mapStatic(date(), moment)),
  socialStudiesPremiumUntil: nullable(mapStatic(date(), moment)),
  sciencePremiumUntil: nullable(mapStatic(date(), moment)),
  premiumCutoff: mapStatic(mapStatic(date(), moment), (m: Moment): PremiumCutoff => m),
})

export const parsePremiumLicenses = Parser.mkRun<PremiumLicensesAttrs>(parsePremiumLicensesAttrs)

export async function fetchPremiumLicenses(): Promise<PremiumLicensesAttrs> {
  return fancyClient.GET('/2/premium-licenses').then(extractData).then(parsePremiumLicenses)
}
